import { create } from 'zustand';
import axios from 'axios';

const initialState = {
    menuData: {},       // 트리로 가공된 메뉴
    categoryCodes: [],  // 카테고리 순서 고정
    rawMenuList: [],    // 동기화용 원본 메뉴
    favoriteMenuData: '',
    clickedCategory: '',
    collapsed: '',
    mainSubTitle: '',
    currentInfo: {
        checkedTopCode: '',
        checkedMenuFlag: '',
        mainTitle: '',
        mainSubTitle: ''
    },
    permissions: '',
    isLoaded: false,
};

export const useMenuStore = create((set, get) => ({
    ...initialState,
    setCollapsed: (topmenuCode) => set({ collapsed: topmenuCode }),

    // [Action] 전체 메뉴 데이터 로드 및 가공
    fetchMenus: async () => {
        try {
            const response = await axios.get('/ptmiapi/main.do');
            const menuList = response.data.menuList;
            
            // 카테고리 순서 고정
            const categories = [...new Set(menuList.map(item => item.SYTMIDNO))];
            
            // 메뉴 트리 가공
            // 롤에 폴더만 남고 그 안의 화면이 빠지면 서버가 폴더만 내려 준다. 화면이 없는 폴더와 대메뉴는 만들지 않는다
            const isScreen = (menu) => typeof menu.MENUSORC === 'string';
            const integratedMenu = {};
            categories.forEach(catCode => {
                const filteredList = menuList?.filter(menu => menu.SYTMIDNO === catCode);
                const menuTree = subMenuTree(filteredList).filter(menu => isScreen(menu) || menu.subMenu.some(isScreen));
                if (menuTree.length === 0) return;
                integratedMenu[catCode] = {
                    SYTMAUTH: filteredList[0]?.SYTMAUTH,
                    SYTMIDNO: filteredList[0]?.SYTMIDNO,
                    SYTMNAME: filteredList[0]?.SYTMNAME,
                    menuTree: menuTree
                };
            });

            set({
                rawMenuList: menuList,
                categoryCodes: categories.filter(catCode => integratedMenu[catCode]),
                menuData: integratedMenu, 
                isLoaded: true 
            });
        } catch (e) {
            console.error('menu list 로딩 중 오류 발생', e);
        }
    },
    
    permissionsData: async (basePath) => {
        try {
            const response = await axios.get('/ptmiapi/getPermissions.do', { params: {menusorc: basePath} });
            set({ permissions: response.data.permissions });
        } catch (e) {
            console.error('permissionsData 로딩 중 오류 발생', e);
        }
    },

    favMenuData: async () => {
        try {
            const response = await axios.get('/ptmiapi/getFavoriteMenuList.do');
            set({ favoriteMenuData: response.data.favoriteMenu })
        } catch(e) {
            console.error('favorite menu list 로딩 중 오류 발생', e);
        }
    },

    // [Action] URL 변화에 따른 메뉴 상태 동기화 (AuthGuard용)
    syncMenu: (pathname, basePath, emogcode) => {
        if (basePath === '/') {
            set({ clickedCategory: '' });
            set({ currentInfo: {
                    collapsed: '',
                    checkedTopCode: '',
                    checkedMenuFlag: '',
                    mainTitle: 'Home'
                }
            });
            return;
        }

        const { rawMenuList, currentInfo, clickedCategory } = get();
        const foundMenu = rawMenuList.find(m => m.MENUSORC && m.MENUSORC === basePath);

        if (foundMenu && foundMenu.SYTMIDNO !== clickedCategory) {
            set({ clickedCategory: foundMenu.SYTMIDNO });
        };

        if (foundMenu && foundMenu.MENUFLAG !== currentInfo.checkedMenuFlag) {
            set({ collapsed: foundMenu.MENUCODE });
            set({ currentInfo: {
                    checkedTopCode: foundMenu.MENUCODE,
                    checkedMenuFlag: foundMenu.MENUFLAG,
                    mainTitle: foundMenu.MENUNAME
                }
            });
        }

        if(emogcode) {
            set({ mainSubTitle: ' - 참여사업' });
        } else if (pathname.includes('/write')) {
            set({ mainSubTitle: ' - 게시글 등록' });
        } else if (pathname.includes('/edit')) {
            set({ mainSubTitle: ' - 게시글 수정' });
        } else if (pathname.includes('/reply')) {
            set({ mainSubTitle: ' - 답글 등록' });
        } else {
            set({ mainSubTitle: '' });
        };
    },

    // 로그아웃 전용 초기화 함수
    resetMenus: () => {
        set(initialState);
    }
    
}));

// 하위 메뉴 가공 함수
const subMenuTree = (data) => {
    let menuItem = [];
    let y = 0;

    for(let i = 0; i < data.length ; i ++) {
        const treeObj = {};
        treeObj.SYTMNAME = data[i].SYTMNAME;
        treeObj.SYTMAUTH = data[i].SYTMAUTH;
        treeObj.SYTMIDNO = data[i].SYTMIDNO;
        treeObj.MENUMETH = data[i].MENUMETH;
        treeObj.MENUNAME = data[i].MENUNAME;
        treeObj.MENUSORC = data[i].MENUSORC;
        treeObj.MENUFLAG = data[i].MENUFLAG;
        treeObj.MENUCODE = data[i].MENUCODE;
        
        if(data[i].MENUCODE === 0) {
            treeObj.subMenu = [];
            menuItem?.push(treeObj);
            if(treeObj.MENUSORC == null) treeObj.MENUSORC = i+1;
        } else { 
            y = menuItem?.findIndex((item) => item.MENUFLAG === data[i].MENUCODE);
            menuItem[y]?.subMenu?.push(treeObj);
        }
    }
    return menuItem;
}
